import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { pickTicketsItemDefaultValues } from './model';
import { pickTicketsItemCreateFormSchema } from './schema';

export function useCreateFormDefinition(pickTicketId: number) {
  return useForm({
    resolver: zodResolver(pickTicketsItemCreateFormSchema),
    defaultValues: { ...pickTicketsItemDefaultValues, pick_ticket_id: pickTicketId },
  });
}
